import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarCollapsed: false,
  theme: 'light',
  notifications: [],
  modals: {
    showProfileModal: false,
    showSettingsModal: false,
    showNotificationModal: false,
  },
  loadingStates: {
    global: false,
    mothers: false,
    subscription: false,
    matchFunding: false,
  },
  searchQuery: '',
  activeTab: 0,
  breadcrumbs: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.unshift({
        id: Date.now(),
        timestamp: new Date().toISOString(),
        ...action.payload,
      });
      // Keep only last 10 notifications
      if (state.notifications.length > 10) {
        state.notifications = state.notifications.slice(0, 10);
      }
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    setModalState: (state, action) => {
      const { modal, isOpen } = action.payload;
      if (state.modals.hasOwnProperty(modal)) {
        state.modals[modal] = isOpen;
      }
    },
    setLoadingState: (state, action) => {
      const { key, isLoading } = action.payload;
      if (state.loadingStates.hasOwnProperty(key)) {
        state.loadingStates[key] = isLoading;
      }
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload;
    },
    clearUI: (state) => {
      state.notifications = [];
      state.modals = initialState.modals;
      state.searchQuery = '';
      state.activeTab = 0;
      state.breadcrumbs = [];
    },
  },
});

export const {
  toggleSidebar,
  setSidebarCollapsed,
  setTheme,
  addNotification,
  removeNotification,
  clearNotifications,
  setModalState,
  setLoadingState,
  setSearchQuery,
  setActiveTab,
  setBreadcrumbs,
  clearUI,
} = uiSlice.actions;

// Selectors
export const selectUI = (state) => state.ui;
export const selectSidebarCollapsed = (state) => state.ui.sidebarCollapsed;
export const selectTheme = (state) => state.ui.theme;
export const selectNotifications = (state) => state.ui.notifications;
export const selectModals = (state) => state.ui.modals;
export const selectLoadingStates = (state) => state.ui.loadingStates;
export const selectSearchQuery = (state) => state.ui.searchQuery;
export const selectActiveTab = (state) => state.ui.activeTab;
export const selectBreadcrumbs = (state) => state.ui.breadcrumbs;
export const selectGlobalLoading = (state) => state.ui.loadingStates.global;

export default uiSlice.reducer;
